<template>
    <div
        :class="{
            'selfie-wrap': true,
            'right': isOwn
        }"
    >
        <template v-if="msgInfo.type!=='lock'">
          <img :src="msgInfo.content" alt="" class="selfie">
        </template>
        <div class="lock" @click="handleUnlock(msgInfo)" v-else></div>
    </div>
</template>

<script>
export default {
  props: {
    msgInfo: {
      type: Object,
      default: () => ({}),
    },
    isOwn: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleUnlock(item) {
      this.$emit('unlock', item);
    },
  },
};
</script>

<style lang="less">
.selfie-wrap {
    display: flex;
    &.right {
        justify-content: flex-end;
    }
    .selfie {
        vertical-align: middle;
        border-radius: 8px;
        border-bottom-left-radius: 0;
        width: 115px;
    }
    .lock {
        background: url('@/assets/images/icon/lock.png') rgb(95,93,100,0.6) center no-repeat;
        background-size: 26px 26px;
        width: 115px;
        height: 160px;
        border-radius: 8px;
        border-bottom-left-radius: 0;
        backdrop-filter: blur(6px);
    }
}
</style>
